import { render, staticRenderFns } from "./confirmBox_component.vue?vue&type=template&id=76f55bfa&"
import script from "./confirmBox_component.vue?vue&type=script&lang=js&"
export * from "./confirmBox_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports